import './SecondaryLayout.scss';
// import { Container } from 'react-bootstrap';

function SecondaryLayout({ children, layoutClassName, showHexBackground, isFluidContainer, containerClassName,...restProps }) {

  const hasHexBackground = showHexBackground ? `HexBackground` : '';

  return (
    <main className={`SecondaryLayout MinHeight-100vh ${layoutClassName}`}>
      <section className={`${hasHexBackground} MinHeight-100vh `  } >
        {/* <Container fluid={isFluidContainer} className={`MinHeight-100vh ${containerClassName}`}> */}
          {children}
        {/* </Container> */}
      </section>
    </main>
  );
}

SecondaryLayout.defaultProps = {
  layoutClassName: '',
  containerClassName: '',
  showHexBackground: true,
  isFluidContainer: true,
}

export default SecondaryLayout;
